<template>
    <div v-if="params.previewMode && invoice.uuid" class="text-primary cursor-pointer">
        {{ invoice?.invoiceNo }}
    </div>
    <invoice-link
        v-else-if="invoice.uuid"
        class="text-primary"
        :invoice-uuid="invoice.uuid"
        :sub-account-uuid="invoice.subAccountUuid"
    >
        {{ invoice?.invoiceNo }}
    </invoice-link>
    <div v-else>...</div>
</template>

<script setup lang="ts">
import InvoiceLink from '@/invoice/InvoiceLink.vue'
import {computed, provide} from 'vue'
import {Invoice} from '@/invoice/types/Invoice'

const props = defineProps({
    params: {
        type: Object as () => {
            data: Invoice,
            context: any,
            previewMode?: boolean
        },
        required: true
    }
})

provide('panelId', props.params?.context.panelId)
provide('panelPathSegment', props.params?.context.panelPathSegment)

const invoice = computed(() => {
    return props.params?.data
})

</script>

<style scoped>

</style>